import { Form, Input, Button } from "antd";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { StyledFlex } from "../Table/index.styled";

interface IProps {
  field: string;
  label?: string;
  value?: string;
  onFinish: (values: any) => void;
  type?: "String" | "Number";
}

const StringOrNumberSearchFilter: React.FC<IProps> = ({
  label,
  field,
  value = "",
  onFinish,
  type,
}) => {
  const { messages } = useIntl();
  const [form] = Form.useForm();
  // const _value = Form.useWatch("value", form); // need for re render

  useEffect(() => {
    form.setFieldValue("value", value);
  }, [value]);

  return (
    <Form
      form={form}
      name={`string_or_number_search_filter_form_${field}`}
      autoComplete="off"
      style={{ padding: "16px" }}
      id={`${label}`}
      className="table-action-form"
      initialValues={{ value }}
      onFinish={({ value }) => {
        onFinish({
          field,
          value: encodeURIComponent(value),
          ...(label && { label }),
        });
      }}
    >
      <Form.Item style={{ marginBottom: 10 }} name="value">
        <Input
          allowClear
          size="middle"
          placeholder={messages["common.search"] as string}
          autoFocus
          type={type === "Number" ? "number" : "text"}
          value={value}
        />
      </Form.Item>

      <Form.Item style={{ marginBottom: 0 }}>
        <StyledFlex style={{ justifyContent: "space-between" }}>
          <Button
            data-testid="reset"
            htmlType="reset"
            type="link"
            onClick={() => onFinish({ field, value: undefined })}
          >
            {messages["common.reset"] as string}
          </Button>
          <Button
            data-testid="submit"
            htmlType="submit"
            type="primary"
            loading={false}
          >
            {messages["common.submit"] as string}
          </Button>
        </StyledFlex>
      </Form.Item>
    </Form>
  );
};

export default StringOrNumberSearchFilter;
